
















































import {
  createAgentConfiguration,
  getAgencyPriceById,
  getAgentPriceById,
  getSharedProductById,
  getTopUpAgentById,
} from '@/api/Topup/topup.api'
import { getAgencyProducts } from '@/utils/functions'
import { Paginator } from '@/utils/interfaces'
import {
  AgencyTopUpPrice,
  GetTopUpPriceDTO,
  TopUpPrice,
} from '@/utils/interfaces/topup.interface'
import { number } from '@/utils/validators'
import { AxiosResponse } from 'axios'
import CreateConfiguration from './CreateConfiguration.vue'
import topUpPriceMixin from '@/utils/mixins/topUpPriceMixin'
import FlatCard from '~/components/FlatCard.vue'

export default topUpPriceMixin.extend({
  components: { CreateConfiguration, FlatCard },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      rules: {
        greatherThan: (value: number) =>
          value >= this.$data.priceReceived ||
          this.$t('validation.must-be-greater-than-equal', {
            value: this.$data.priceReceived,
          }),
        number: (value: string) =>
          number(value) || this.$t('validation.must-be-a-number'),
      },
      mySettings: {
        cost: 0 as string | number,
      } as TopUpPrice,
      myPrices: {} as {} | TopUpPrice,
      loading: false,
      priceText: '',
    }
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
  },
  methods: {
    async createMyPrice() {
      try {
        this.loading = true
        const cost = this.mySettings.cost
          ? this.mySettings.cost
          : (this.mySettings as { cost: number; price: number }).price
        const body = {
          agent: this.$store.getters.profile.uuid,
          cost: cost,
          is_active: true,
          product: this.product.uuid,
          currency: this.defaultCurrency as 'CUP' | 'USD',
        }
        const response = await createAgentConfiguration(body)
        this.myPrices = response.data
      } finally {
        this.loading = false
      }
    },
  },
  async mounted(): Promise<void> {
    let response: AxiosResponse<Paginator<AgencyTopUpPrice | GetTopUpPriceDTO>>
    let getter: (
      uuid: string,
    ) => Promise<AxiosResponse<GetTopUpPriceDTO | AgencyTopUpPrice>>

    this.loading = true
    try {
      const agent = await getTopUpAgentById(this.$store.getters.profile.uuid) //gets yout topup price data
      if (agent.data.topup_prices) {
        const prices = agent.data.topup_prices.filter(
          price => price.product === this.product.uuid,
        ) // filters by current tab product
        if (prices.length) {
          const myPrice = await getAgentPriceById(
            (prices[0] as TopUpPrice & { uuid: string }).uuid,
          )
          this.myPrices = myPrice.data
          this.mySettings = myPrice.data
        } // si hay precios configurados, los guarda para la configuracion de los hijos
      }
      if (this.$store.getters.profile.role === 'ADMIN') {
        response = await getAgencyProducts({
          product__uuid: this.product.uuid,
        })

        if (response.data.results.length) {
          getter = getAgencyPriceById
          if (response.data.results[0].shared_provider) {
            getter = getSharedProductById
          }
          const prices = await getter(response.data.results[0].uuid)
          this.mySettings = prices.data // si eres admin te pone los precios de la agencia
        } else this.$emit('show-exit-card')
        this.priceReceived = Number(this.mySettings.price)
        this.priceText =
          response.data.results
            .map(price =>
              Number(price.price).toLocaleString('en-US', {
                minimumFractionDigits: 4,
              }),
            )
            .join(' | ') + ' USD'
      } else {
        this.priceReceived = Number(this.mySettings.cost)
        this.priceText = this.priceReceived.toLocaleString('en-US', {
          minimumFractionDigits: 4,
        })
      }
    } finally {
      this.loading = false
    }
  },
  watch: {
    priceReceived(value: number) {
      this.$emit('new-price', value)
    },
  },
})
